import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import withContentBlock from '../withContentBlock'
import BOTFeaturedArticles from './BOTFeaturedArticles'

export default compose(
  withType({ type: 'BOTFeaturedArticles' }),
  withContentBlock
)(BOTFeaturedArticles)
